"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useId } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWater } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import useIsMobileDevice from "@/hooks/isMobileDevice";
interface WaveCreatorBadgeProps {
  readonly tooltipId?: string | undefined;
  readonly onBadgeClick?: (() => void) | undefined;
  readonly size?: "default" | "compact" | undefined;
}
export const WaveCreatorBadge: React.FC<WaveCreatorBadgeProps> = t0 => {
  const $ = _c(20);
  const {
    tooltipId: t1,
    onBadgeClick,
    size: t2
  } = t0;
  const tooltipId = t1 === undefined ? "wave-creator-badge" : t1;
  const size = t2 === undefined ? "default" : t2;
  const isMobile = useIsMobileDevice();
  const id = useId();
  const uniqueTooltipId = `${tooltipId}-${id}`;
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
  const showTooltip = isMobile === false;
  const dataTooltipId = showTooltip ? uniqueTooltipId : undefined;
  const buttonSizeClassName = size === "compact" ? "tw-h-[18px] tw-w-[18px]" : "tw-h-5 tw-w-5";
  const iconSizeClassName = size === "compact" ? "tw-h-[9px] tw-w-[9px]" : "tw-h-2.5 tw-w-2.5";
  let t3;
  if ($[0] !== onBadgeClick) {
    t3 = e => {
      e.preventDefault();
      e.stopPropagation();
      setIsTooltipOpen(false);
      onBadgeClick?.();
    };
    $[0] = onBadgeClick;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsTooltipOpen(true);
    t5 = () => setIsTooltipOpen(false);
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  const t6 = `tw-inline-flex ${buttonSizeClassName} tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-solid tw-border-white/15 tw-bg-white/5 tw-text-white/60 tw-outline-none tw-ring-0 tw-transition-colors tw-duration-200 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white/20 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-iron-950 desktop-hover:hover:tw-border-white/20 desktop-hover:hover:tw-bg-white/10 desktop-hover:hover:tw-text-white/70`;
  let t7;
  if ($[4] !== dataTooltipId) {
    t7 = dataTooltipId && {
      "data-tooltip-id": dataTooltipId
    };
    $[4] = dataTooltipId;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = `${iconSizeClassName} tw-flex-shrink-0 tw-text-current`;
  let t9;
  if ($[6] !== t8) {
    t9 = <FontAwesomeIcon icon={faWater} className={t8} />;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t3 || $[9] !== t6 || $[10] !== t7 || $[11] !== t9) {
    t10 = <button type="button" onClick={t3} onMouseEnter={t4} onMouseLeave={t5} className={t6} aria-label="View created waves" {...t7}>{t9}</button>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== isTooltipOpen || $[14] !== showTooltip || $[15] !== uniqueTooltipId) {
    t11 = showTooltip && <Tooltip id={uniqueTooltipId} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES} isOpen={isTooltipOpen}><span className="tw-text-xs">View created waves</span></Tooltip>;
    $[13] = isTooltipOpen;
    $[14] = showTooltip;
    $[15] = uniqueTooltipId;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};